import { useDispatch, useSelector } from 'react-redux'
import {
  selectCustomerSubscriptionData,
  selectEnergyCharacteristicsSubscriptionData,
  selectEnergyContractSubscriptionData,
  selectGasMeterSubscriptionData,
} from '@/containers/SubscriptionFormPage/SubscriptionFormSelectors'

import {
  selectCommonFormConfigurationData,
  selectOfferModuleConfigurationData,
} from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSelectors'
import { useTranslation } from 'react-i18next'
import { clubSelectraModuleActions } from '@/containers/SubscriptionFormPageNew/Components/ClubSelectra/ClubSelectraSagas'
import {
  selectClubSelectraState,
  selectConfig,
  selectPersonalClientSubscriptionData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { useSnackbar } from 'baseui/snackbar'
import { useState } from 'react'

// to-do-v2: selectGasMeterSubscriptionData no more used in V2 and all in path SubscriptionFormPage/*
const useClubSelectra = version => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()
  const { energyType } = useSelector(selectEnergyCharacteristicsSubscriptionData)
  const { offerId, providerExternalId } = useSelector(selectEnergyContractSubscriptionData)
  const { providerExternalIdGas } = useSelector(selectGasMeterSubscriptionData)
  const { offers } = useSelector(selectOfferModuleConfigurationData)
  const { isClubSelectraRegistered } = useSelector(selectCustomerSubscriptionData)
  const clubSelectra = useSelector(selectClubSelectraState)

  const offerName =
    offers && offerId != null ? Object.keys(offers).find(name => String(offers[name]) === String(offerId)) || '' : ''

  const isLoading = clubSelectra.loading
  const success = clubSelectra.success
  const message = clubSelectra.message || ''
  const error = clubSelectra.error || ''

  const sourceClientIdSelector = version === 'legacy' ? selectCommonFormConfigurationData : selectConfig

  const sourceClientIdData = useSelector(sourceClientIdSelector) || {}
  const clientId = version === 'legacy' ? sourceClientIdData?.id : sourceClientIdData?.contactId

  const sourceClientSelector =
    version === 'legacy' ? selectCustomerSubscriptionData : selectPersonalClientSubscriptionData

  const client = useSelector(sourceClientSelector) || {}
  const { zohoId } = client || ''
  const contactFirstName = version === 'legacy' ? client?.name ?? '' : client?.firstName ?? ''
  const contactLastName = version === 'legacy' ? client?.surname ?? '' : client?.lastName ?? ''
  const contactEmail = client?.email ?? ''

  const createClubSelectra = () => {
    if (isLoading) return
    if (currentMissingLabels.length > 0) {
      setMissingLabelsClicked(currentMissingLabels)
      return
    }
    setMissingLabelsClicked([])
    dispatch({
      type: clubSelectraModuleActions.CREATE_CLUB_SELECTRA,
      enqueue,
      payload: buildPayload(),
      version,
    })
  }

  const [missingLabelsClicked, setMissingLabelsClicked] = useState([])

  const isEmptyValue = value => value == null || String(value).trim() === ''

  const mandatoryEntries = [
    [t('subscriptionForm:customer_module.firstname.label'), contactFirstName],
    [t('subscriptionForm:customer_module.lastname.label'), contactLastName],
    [t('subscriptionForm:customer_module.email.label'), contactEmail],
    [t('subscriptionForm:zoho_module.module_title'), zohoId],
    ['Subscription id', clientId],
    [t('subscriptionForm:characteristics_module.energy_type.label'), energyType],
    [t('subscriptionForm:characteristics_module.contract_type.label'), offerName],
  ]

  const currentMissingLabels = mandatoryEntries.filter(([, value]) => isEmptyValue(value)).map(([label]) => label)

  const labelsToShow = missingLabelsClicked.length > 0 ? missingLabelsClicked : currentMissingLabels

  const buildPayload = () => {
    const payload = {
      contactFirstName,
      contactLastName,
      contactEmail,
      version,
      clientId,
      zohoContactId: zohoId,
      energyType,
      offerName,
    }

    if ((energyType === 'elec' || energyType === 'dual') && providerExternalId) {
      payload.provider_external_id_elec = providerExternalId
    }

    if ((energyType === 'gas' || energyType === 'dual') && providerExternalIdGas) {
      payload.provider_external_id_gas = providerExternalIdGas
    }

    return payload
  }

  const disabled = isLoading || isClubSelectraRegistered === true || currentMissingLabels.length > 0 || success === true

  return {
    t,
    isLoading,
    success,
    message,
    error,
    isClubSelectraRegistered,
    energyType,
    offerId,
    offers,
    zohoId,
    clientId,
    contactFirstName,
    contactLastName,
    contactEmail,
    offerName,
    labelsToShow,
    currentMissingLabels,
    disabled,
    createClubSelectra,
  }
}

export default useClubSelectra
